module.exports = __webpack_public_path__ + "static/results-cover-d94cadfc7f70d06e86676fdb2bb5e949.png";